// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.get-verso",
    name: "Verso",
    homepage: "https://get-verso.com",
    image_id: "109d7c90-86ed-4ee0-e17d-3c87624ddf00",
    app: {
        browser: "https://get-verso.com",
        ios: "https://apps.apple.com/app/btu-protocol/id1539304605",
        android: "https://play.google.com/store/apps/details?id=com.btuprotocol.btu_wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "verso://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map